module.exports = __webpack_public_path__ + "img/whiteFilter.618c1d5e.svg";